import Swal from "sweetalert2";
import { clearOrdersIndicators, clearProductsIndicators, processRequest, setError, setOrdersIndicators, setProductsIndicators } from "./Slice";
import apiConnection from "../Connection";

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    didOpen: (toast) => {
        // toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});

export const loadIndicatorsProducts = () => {
    return async (dispatch, getState) => {
        dispatch(clearProductsIndicators());
        dispatch(processRequest());
        await apiConnection.get(`/Products/getIndicatorsProducts`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setProductsIndicators({
                        msg: 'Indicadores disponibles',
                        indicators: response.data.data,
                    })
                );
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

export const loadIndicatorsOrders = () => {
    return async (dispatch, getState) => {
        dispatch(clearOrdersIndicators());
        dispatch(processRequest());
        await apiConnection.get(`/Orders/getIndicatorsOrders`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setOrdersIndicators({
                        msg: 'Indicadores disponibles',
                        indicators: response.data.data,
                    })
                );
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}